import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface LoaderInstance {
  loaderId: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProgressLoaderService {
  /**
   * Manages a list of all the loaders that are actively shown on screen.
   */
  private _activeLoaderList: LoaderInstance[] = [];

  private _activeLoaderSub$ = new BehaviorSubject<LoaderInstance | null>(null);
  activeLoader$ = this._activeLoaderSub$;

  constructor() {}

  show(message: string = 'Loading'): string {
    const loaderId = `${Date.now()}${Math.random().toString().slice(2, 10)}`;

    this._activeLoaderList.push({ loaderId, message });

    this._updateActiveLoader();

    return loaderId;
  }

  hide(loaderId: string): void {
    if (loaderId) {
      this._activeLoaderList = this._activeLoaderList.filter((loader) => loader.loaderId != loaderId);
      this._updateActiveLoader();
    }
  }

  private _updateActiveLoader() {
    if (this._activeLoaderList.length) {
      this._activeLoaderSub$.next(this._activeLoaderList[this._activeLoaderList.length - 1]);
    } else {
      this._activeLoaderSub$.next(null);
    }
  }
}
